import FormImportDictionaries from './FormImportDictionaries';



export default FormImportDictionaries;
